import {useQuery} from 'react-query';
import getAddressByLatLngSearch from '.';

const useGetAddressByLatLngSearch = (lat?: string, lng?: string) => {
  const {data, isLoading} = useQuery({
    queryKey: ['coordinate-based-search', lat, lng],
    queryFn: getAddressByLatLngSearch,
    enabled: !!lat && !!lng,
  });

  // Transform the response because of the api changes
  const address = data
    ? {
        state: data.state?.[0] ?? null,
        city: data.city?.[0] ?? null,
        town: data.town?.[0] ?? null,
      }
    : null;

  return {
    address,
    isLoading,
  };
};

export default useGetAddressByLatLngSearch;
